import { LOAD_STORAGE, SET_ITEM, SET_ITEMS, LOCAL_STORAGE_INIT_STATE } from './types';

export default function(state = LOCAL_STORAGE_INIT_STATE, action) {
  switch (action.type) {
    case SET_ITEM:
      return {
        ...state,
        ...action.payload,
      };
    case SET_ITEMS:
      return {
        ...state,
        ...action.payload,
      };
    case LOAD_STORAGE:
      return action.localStorage;
    default:
      return state;
  }
}
